import type { IconSvgObject } from './types';

const ArrowDataTransferHorizontalIcon: IconSvgObject = [
  ["path", { d: "M19.0006 9H5.0003L8.0003 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 15H19.0003L16.0003 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDataTransferHorizontalIcon;
